import React from 'react'

function Loader() {
  return (
    <div className='flex flex-row items-center justify-center w-full h-[100vh]'>
        <img src="https://media.tenor.com/7NX24XoJX0MAAAAM/loading-fast.gif" alt="" />
    </div>
  )
}

export default Loader